import { MKLogLevel } from "../../enums";

/**
 * MKLog class.
 * @internal
 */
export abstract class MKLog {
    /**
     * Current log level.
     */
    private static logLevel: MKLogLevel = MKLogLevel.Debug;

    /**
     * Get the log tag with the given label.
     * @param tag the log level label
     * @returns the log tag.
     */
    private static logTag(label?: string): string {
        if (this.logLevel !== MKLogLevel.Off && label) {
            return `[MKPlayer: ${label}]: `;
        }
        return "";
    }

    /**
     * Set log level.
     * @param logLevel new log level to set.
     */
    public static setLogLevel(logLevel: MKLogLevel): void {
        this.logLevel = logLevel;
    }

    /**
     * Log message
     * @param message optional message to log.
     * @param options optional parameters.
     */
    public static log(message?: any, ...options: any[]): void {
        if (typeof console === undefined) return;
        if (this.logLevel === MKLogLevel.Log) {
            console.log(this.logTag("LOG") + message, ...options);
        }
    }

    /**
     * Debug log message
     * @param message optional message to log.
     * @param options optional parameters.
     */
    public static debug(message?: any, ...options: any[]): void {
        if (typeof console === undefined) return;
        if (this.logLevel === MKLogLevel.Debug || this.logLevel === MKLogLevel.Log) {
            console.debug(this.logTag("DBG") + message, ...options);
        }
    }

    /**
     * Warning log message
     * @param message optional message to log.
     * @param options optional parameters.
     */
    public static warn(message?: any, ...options: any[]): void {
        if (typeof console === undefined) return;
        if (this.logLevel !== MKLogLevel.Off) {
            console.warn(this.logTag("WRN") + message, ...options);
        }
    }

    /**
     * Error log message
     * @param message optional message to log.
     * @param options optional parameters.
     */
    public static error(message?: any, ...options: any[]): void {
        if (typeof console === undefined) return;
        if (this.logLevel !== MKLogLevel.Off) {
            console.error(this.logTag("ERR") + message, ...options);
        }
    }
}